function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 7C10.2533 7 6 11.2533 6 16.5C6 21.7467 10.2533 26 15.5 26C20.7467 26 25 21.7467 25 16.5C25 15.3037 24.7789 14.159 24.3752 13.1046",
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 11.5V2.5L22 7L15 11.5Z"
});
const Svg31Px = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 31,
  height: 31,
  viewBox: "0 0 31 31",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(Svg31Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/31px.516a638c.svg";
export { ForwardRef as ReactComponent };